import * as React from 'react';

export default function IconPassword({ className }: { className?: string }) {
  return (
    <svg fill="none" viewBox="0 0 24 24" className={className}>
      <path
        d="M12 13.5a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1Z"
        fill="#000"
        fillOpacity=".65"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.75 8.929V9H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2h-.75v-.071c0-1.22 0-3.104-.756-4.69-.396-.83-1.005-1.593-1.925-2.141-.916-.546-2.09-.848-3.569-.848-1.48 0-2.653.302-3.569.848-.92.548-1.529 1.31-1.925 2.142-.757 1.585-.756 3.469-.756 4.689Zm2.11-4.044C7.26 6.144 7.25 7.717 7.25 9H6.5h10.25c0-1.283-.01-2.856-.61-4.115-.289-.606-.71-1.125-1.339-1.498C14.17 3.01 13.277 2.75 12 2.75c-1.277 0-2.17.26-2.801.637-.628.373-1.05.892-1.34 1.498ZM19 10.5H5a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5Z"
        fill="#000"
        fillOpacity=".65"
      />
    </svg>
  );
}
